

















import { Component, Vue } from 'vue-property-decorator';
import Footer from "@/components/classBuilder/Footer.vue";
import HowItWorks from "@/components/classBuilder/HowItWorks.vue";
import SelectExerciseBlock from "@/components/classBuilder/SelectExerciseBlock.vue";
import HeaderSection from "@/components/classBuilder/HeaderSection.vue";

@Component({
  components: {
    HeaderSection,
    SelectExerciseBlock,
    HowItWorks,
    Footer

  },
})
export default class ClassBuilder extends Vue {
  private styleId:string = '';
  private teacherId:string = '';

  private handleSelectedExercise(exerciseId: string) {

  }
  private handleSelectedMusic() {

  }

  private handleSelectStyle(id: string) {
    this.styleId = id;
    this.teacherId = '';
  }

  private handleSelectTeacher(id: string) {
    this.teacherId = id;
  }
}
